var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreedom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6495 49C26.6495 49 7 43.1628 7 14.3476V3.32031H46.3058V14.3476C46.3058 42.1315 26.6562 49 26.6562 49",
    fill: "#51AF3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8965 14.8205H21.8721V23.8737H37.9033V26.5804C37.9033 31.167 36.5877 34.8669 29.4943 34.8803H21.8721V46.8401C24.5032 48.4467 26.4088 49.0001 26.4088 49.0001C26.4088 49.0001 46.3054 42.2068 46.3054 14.7272V6.50732C46.3054 11.0939 44.2439 14.7272 37.8965 14.8139",
    fill: "#0F5431"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreedom);
export default __webpack_public_path__ + "static/media/freedom.74465b9b29c9d9e6a99bbbe51237511e.svg";
export { ForwardRef as ReactComponent };